import { render } from "./PokemonOptions.vue?vue&type=template&id=f868281c"
import script from "./PokemonOptions.vue?vue&type=script&lang=js"
export * from "./PokemonOptions.vue?vue&type=script&lang=js"

import "./PokemonOptions.vue?vue&type=style&index=0&id=f868281c&lang=css"

import exportComponent from "/home/shicksal/Documentos/Trabajos/Vue-js/vue-udemy/04-pokemon-game/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__